import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import LegalDocument from './LegalDocument';
import { clientTerms } from './Client-Terms';
import { artistTerms } from './Artist-Terms';
import { privacyPolicy } from './Privacy-Policy';

const LegalRouter = () => {
  const { documentType } = useParams();

  const documents = {
    'terms-and-conditions': clientTerms,    // For client eSignature liability release
    'client-terms': clientTerms,            // Same as above
    'artist-terms': artistTerms,            // For artists/shops signing up to platform
    'platform-terms': artistTerms,         // Alternative URL for artist terms
    'privacy-policy': privacyPolicy,        // Privacy policy for all users
  };

  const document = documents[documentType];

  if (!document) {
    return <Navigate to="/legal/terms-and-conditions" replace />;
  }

  return <LegalDocument document={document} />;
};

export default LegalRouter;